<template>
  <div>
    <!-- 기본정보 -->
    <field-select-module
      v-model="form.stdInfo"
      :board="board" :is-print="isPrint" :vislbleAlert="true"
      :options="[
        { type: 'text', label: '문서번호', readonly: true, visibleWhenValue: true},
        { type: 'alert', label: '알림 대상자 선택' },
        ]"
    />

    <!-- 문서정보 -->
    <write-grid-container title="문서정보" v-model="form.문서정보" :options="gridContainerOptions" class="sub mt-7">
      <template slot-scope="{ index, label, value, dataType }">
        <div v-if="isPrint" class="printing">
          <div class="print-input">{{ form.문서정보[value] }}</div>
        </div>

        <div v-else class="write-grid-container-col">
          <vs-select v-if="dataType === 'selector1'" class="w-full" autocomplete v-model="form.문서정보[value]" >
            <vs-select-item v-for="item in ['사내', '그룹사내', '팀내', '제한']" :text="item" :value="item"/>
          </vs-select>
          <vs-select v-else-if="dataType === 'selector2'" class="w-full" autocomplete v-model="form.문서정보[value]" >
            <vs-select-item v-for="item in ['1년', '3년', '5년', '7년', '10년', '영구']" :text="item" :value="item"/>
          </vs-select>
          <ml-input v-else-if="dataType === 'readonly'" class="w-full" v-model="form.문서정보[value]" visible-counter :readonly="true"/>
          <ml-input v-else class="w-full" v-model="form.문서정보[value]" visible-counter />
        </div>
      </template>
    </write-grid-container>

    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i> 목표 개선 계획서</h5>
      <div class="writeGridContainer">
        <div class="writeGridLineItem">
          <div>계획일자</div>
          <div>
            <p v-if="isPrint" class="print-input">{{ form.계획서.계획일자 }}</p>
            <date-selector v-else class="w-full xl:w-auto" v-model="form.계획서.계획일자" />
          </div>
        </div>

        <div class="writeGridLineItem">
          <div class="flex items-center">
            목표
            <div v-if="isShowPopupButton && !isPrint" class="ml-auto block md:hidden">
              <vs-button color="secondary" type="border" @click="showListPopup = true">공장별 세부목표</vs-button>
            </div>
          </div>
          <div v-if="isPrint" class="print-quill ql-editor" v-html="form.계획서.목표"></div>
          <div v-else class="grid md:flex gap-4">
            <div class="flex-1">
              <quill-editor class="quill-editor" v-model="form.계획서.목표" :options="quillOption"></quill-editor>
            </div>
            <div v-if="isShowPopupButton" class="ml-auto hidden md:block">
              <vs-button color="secondary" type="border" @click="showListPopup = true">공장별 세부목표</vs-button>
            </div>
          </div>
        </div>

        <div class="writeGridLineItem" >
          <div>팀목표</div>
          <p v-if="isPrint" class="print-input">{{ form.계획서.팀목표 }}</p>
          <ml-input v-else class="w-full" v-model="form.계획서.팀목표" />
        </div>
      </div>
    </div>

    <table-custom
      class="mt-28px"
      :board="board"
      :is-print="isPrint"
      :print-vertical="isPrint"
      title="평가지표"
      :tableData="[
        { id: '작업활동', title: '작업/활동', type: 'text', placeholder: '내용', width: '160px' },
        {
          id: '환경영향',
          title: '환경영향',
          type: 'select',
          selectData: ['대기', '수질', '에너지', '폐기물', '소음, 진동', '토양', '생태계', '천연자원', '기타'],
          placeholder: '선택',
          width: '160px'
        },
        { id: '측정방법', title: '측정방법(단위)', type: 'customType', width: '300px' },
        { id: '현수준', title: '현수준', type: 'textarea', placeholder: '내용', width: '300px' },
        { id: '목표', title: '목표', type: 'textarea', placeholder: '내용', width: '300px' },
      ]"
      :mobile="['작업활동', '환경영향']"
      v-model="form.평가지표"
    >
      <template #customType="{ index, trData, id, input }">
        <div v-if="isPrint" class="print-input">{{ form.평가지표[index].측정방법 }} {{ form.평가지표[index].측정단위 !== '기타'? form.평가지표[index].측정단위 : form.평가지표[index].측정단위기타 }}</div>
        <div v-else class="flex">
          <ml-input class="w-full" v-model="form.평가지표[index].측정방법"/>
          <div class="ml-2">
            <vs-select autocomplete v-model="form.평가지표[index].측정단위" style="width: 80px;">
              <vs-select-item v-for="item in ['ppm', '%', '기타']" :text="item" :value="item"/>
            </vs-select>
            <ml-input v-show="form.평가지표[index].측정단위 === '기타'" class="mt-2" v-model="form.평가지표[index].측정단위기타" placeholder="직접입력" style="width: 80px;"/>
          </div>
        </div>
      </template>
    </table-custom>

    <table-custom
      class="mt-28px"
      :board="board"
      :is-print="isPrint"
      :print-vertical="isPrint"
      title="세부 추진 사항"
      :tableData="[
        { id: '담당자', title: '담당자', type: 'text', placeholder: '내용', width: '160px' },
        { id: '일정', title: '일정', type: 'customType', width: '300px' },
        { id: '계획', title: '계획', type: 'customType', width: '300px', style: { padding : 0 } },
      ]"
      v-model="form.세부추진사항"
    >
      <template #customType="{ index, trData, id, input }">
        <div v-if="id === '일정'">
          <div v-if="isPrint" class="print-input">{{ form.세부추진사항[index].일정시작 }} ~ {{ form.세부추진사항[index].일정종료 }}</div>
          <div v-else class="flex" style="align-items: center;">
            <date-selector class="w-full" v-model="form.세부추진사항[index].일정" />
            <span class="mx-2">~</span>
            <date-selector class="w-full" v-model="form.세부추진사항[index].일정종료" />
          </div>
        </div>
        <div v-else-if="id === '계획'">
          <div class="flex">
            <p v-if="isPrint" style="white-space: nowrap; flex-shrink: 0; padding: 6px;">{{ form.세부추진사항[index].계획데이터 }}</p>
            <vs-select v-else autocomplete v-model="form.세부추진사항[index].계획데이터" style="padding: 6px;">
              <vs-select-item v-for="item in ['에너지', '폐기물', '대기', '수질', '소음, 진동', '민원']" :text="item" :value="item"/>
            </vs-select>

            <div style="border-left: 1px solid #cdcdcd; padding: 6px;" class="w-full">
              <p v-if="isPrint">{{ form.세부추진사항[index].계획내용 }}</p>
              <ml-textarea v-else class="m-0 w-full flex-1" v-model="form.세부추진사항[index].계획내용" rows="3" />
            </div>
          </div>
        </div>
      </template>
    </table-custom>

    <!-- 파일첨부 -->
    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>

    <PopupLoadPrevBoard title="공장별 세부목표" :setBoardId="selectPopup" v-model="showListPopup" @selectRowData="loadGoalData" />
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import WriteGridContainer from "@/components/WriteGridContainer.vue";
import DateSelector from "@/components/selector/DateSelector.vue";
import TableCustom from "@/components/TableCustom.vue";
import PopupLoadPrevBoard from "@/popup/PopupLoadPrevBoard.vue";
import PopupImageList from "@/popup/PopupImageList.vue";
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import {quillEditor} from 'vue-quill-editor'

export default {
  components: {
    PopupImageList,
    PopupLoadPrevBoard,
    TableCustom,
    DateSelector,
    WriteGridContainer,
    FieldSelectModule,
    FileUploadModule,
    quillEditor
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  validations: {
    form: {
      계획서: {
        계획일자: { required },
      },
    },
  },
  computed: {
    isShowPopupButton() {
      return this.form.stdInfo.field_name !== ''
    },
    selectPopup() {
      // 사업장 선택에 따른 팝업 게시판 ID
      // if (this.form.stdInfo.field_name) {
      //   if (this.form.stdInfo.field_name.indexOf('인천공장') > -1) {
      //     return 958
      //   } else if (this.form.stdInfo.field_name.indexOf('당진공장') > -1) {
      //     return 959
      //   } else if (this.form.stdInfo.field_name.indexOf('포항공장') > -1) {
      //     return 960
      //   } else if (this.form.stdInfo.field_name.indexOf('중앙기술연구소') > -1) {
      //     return 1062
      //   }
      // }

      return 957
    },
    currentId() {
      // 현재 페이지의 URL을 반환하되, ? 이후의 쿼리스트링은 제외한다.
      const result = window.location.href.split("?")[0];
      return result.split("/").pop();
    },
  },
  data() {
    return {
      showListPopup : false,
      quillOption: {
        placeholder: '내용을 입력해주세요'
      },
      form: {
        stdInfo: {},
        문서정보: { 보안등급: "사내", 보존년한: "3년" },
        계획서: {
          계획일자: "",
          목표: "",
          팀목표: "",
        },
        평가지표: [],
        세부추진사항: [],

        fileList: [],
      },
      gridContainerOptions: {
        dataTypes: ["selector1", "selector2"],
        labels: ["보안등급", "보존년한"],
        values: ["보안등급", "보존년한"],
      },
    };
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);

        if (this.currentId !== 'write') {
          if (this.form.문서정보.문서번호 === '') {
            this.form.문서정보.문서번호 = this.currentId
          }
        }

      },
    },
  },
  created() {
    const keys = Object.keys(this.form);
    for (const key of keys) {
      if (this.value[key]) {
        this.form[key] = this.value[key];
      }
    }
  },
  methods: {
    validate() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        if (!this.$v.form.계획서.계획일자.required) return "계획일자를 반드시 입력해야 합니다";
      }
    },
    setApprovalButtons(template) {
      const btn = JSON.parse(JSON.stringify(template.resend))
      btn.content = "환경 목표 개선 실적서 작성";
      btn.shouldShow.custom = ["approved"].indexOf(this.board.statusCode) > -1 // 승인된 경우에만
      btn.emits.click = (func) => {
        this.$router.push({
          name: "write|tab",
          params: { boardId: 907, pageType: 'list' },
        });
      }

      return [btn, template.revision, template.resend, template.print, template.delete, template.move, template.save]
    },

    loadGoalData(data) {
      if (data && data.post_content) {
        const content = JSON.parse(data.post_content)
        const body = content.body

        this.form.계획서.목표 = body.subInfo.목표
        this.form.fileList = body.fileList
      }
    },
  },
};
</script>

<style scoped lang="scss">
/* 에디터의 행 수 설정 */
.quill-editor::v-deep {
  .ql-editor {
    min-height: calc(12px * 2 + 1.42rem * 15); /* 15행 기준 */
  }
}

/* 인쇄 시 위지윅(목표) 내용 - 이미지/서식 그대로 출력 */
.print-quill::v-deep {
  padding: 0;

  img {
    max-width: 100%;
    height: auto;
  }
}
</style>
